import { render, staticRenderFns } from "./AppTitle.vue?vue&type=template&id=6b64e3f5&scoped=true&"
import script from "./AppTitle.vue?vue&type=script&lang=js&"
export * from "./AppTitle.vue?vue&type=script&lang=js&"
import style0 from "./AppTitle.vue?vue&type=style&index=0&id=6b64e3f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64e3f5",
  null
  
)

export default component.exports